import { Component, OnInit,Output, EventEmitter } from '@angular/core';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { environment } from '../../../../environments/environment';
import { FacilityDetailsService } from '../../services/facility-details.service';
import { Router } from '@angular/router';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-onboarding-modal',
  templateUrl: './onboarding-modal.component.html',
  styleUrls: ['./onboarding-modal.component.css']
})
export class OnboardingModalComponent implements OnInit {
  constructor(private rootScopeService:RootScopeService,private facilityDetailService: FacilityDetailsService,private _router: Router,    private amplitudeAnalytics: AmplitudeAnalyticsService
    ) { }
  cloudBasePath: string;
  rootScopeData:RootScopeDeclare;

  @Output() onClose:EventEmitter<string>=new EventEmitter();
  ngOnInit() {
    this.cloudBasePath=environment.cloudBasePath;
    this.getRootScopeData();
  }
  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData =>
      { this.rootScopeData = rootScopeData;

    });
  }
  updateSoftware(){
    const inputJson: any = {};
    inputJson.showOnboardingPopup = 'false';
    this.facilityDetailService.saveUserPreference(inputJson)
    .subscribe(
      data => {
       sessionStorage.setItem('hideOutdatedOnboardingPopup', 'true' );
       this.rootScopeData.popupData.showOnboardingPopup = false;
       this.onClose.emit('onboardingModal');
       //this.amplitudeAnalytics.logEvent('Onboarding Outdate Software- Update Software');
       this._router.navigate(['/software']);
      },
      error => {
        console.error('API failed.');
      }
    );
  }

  skipUpdateSoftware(){
    const inputJson: any = {};
    inputJson.showOnboardingPopup = 'true';
    this.facilityDetailService.saveUserPreference(inputJson)
    .subscribe(
      data => {
       sessionStorage.setItem('hideOutdatedOnboardingPopup', 'true' );
       this.rootScopeData.popupData.showOnboardingPopup = true;
       this.onClose.emit('onboardingModal');
       //this.amplitudeAnalytics.logEvent('Onboarding Outdate Software- Skip Update Software');

      },
      error => {
        console.error('API failed.');
      }
    );
  }
}
